export default __webpack_public_path__ + "static/media/building-regular.82fa7bbc.svg";